"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("@mui/material/Button"));
function formatPrice(price) {
    var priceNumber = Number(price);
    if (Number.isInteger(priceNumber)) {
        return "".concat((priceNumber / 100).toFixed(2).replace('.', ','), " \u20AC");
    }
}
var BuyNowButton = function (_a) {
    var price = _a.price, setBuyFormEnabled = _a.setBuyFormEnabled;
    var BuyNowButtonComp = (0, material_1.styled)(Button_1.default)(function (_a) {
        var theme = _a.theme;
        return ({
            color: '#fff',
            border: '1px solid #000',
            backgroundColor: '#000',
            '&:hover': {
                backgroundColor: '#000',
            },
        });
    });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "buynow-button" }, { children: (0, jsx_runtime_1.jsxs)(BuyNowButtonComp, __assign({ onClick: function () { return setBuyFormEnabled(true); } }, { children: ["Comprar ahora (", formatPrice(price), ")"] })) })));
};
exports.default = BuyNowButton;
//# sourceMappingURL=BuyNowButton.js.map